import ITableRow from "../models/ITableRow";
import { Action, ActionType } from "../actions/TableActions";
import {
  Action as CsvAction,
  ActionType as CsvActionType,
} from "../actions/CsvUploaderActions";

// Define the state interface for the current reducer
export interface IState {
  calculatedTableRows: ITableRow[];
}

// Define the initial state
export const initialState: IState = {
  calculatedTableRows: [],
};

/*
 * Reducer takes 2 arguments
 * state: The state of the reducer. By default initialState (if there was no state provided)
 * TODO: action: Action to be handled. (to be added in the inbreeding calculation story)
 */
export function reducer(
  state: IState = initialState,
  action: Action | CsvAction
) {
  switch (action.type) {
    case ActionType.ReceiveCalculatedTableRows: {
      return {
        ...state,
        calculatedTableRows: action.payload,
      };
    }
    case CsvActionType.UploadCsv: {
      return {
        ...state,
        calculatedTableRows: action.payload.csvData.map((row) => ({
          // the || '' replaces invalid caracters in bullcodes on the first load
          // when adding new bulls, it will already hold this fixed data
          "Cow number/ name": row.cowNumber || "",
          "Cow Sire": row.sire || "",
          "Maternal Grandsire": row.grandSire || "",
          Issues: "",
        })),
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/reducers/InbreedingCalculationsReducer.ts